// extracted by mini-css-extract-plugin
export default {"modalTrigger":"_3P2HI2","dismissButton":"_1xJoN8","closeButton":"_1DAKxv"};